export default "__VITE_ASSET__C5ptRYj3__"